import type { LightboxState, LightboxElements } from './types';
import { loadImageWithFallback } from './imageLoader';
import { resetZoom } from './zoom';

export function showImage(state: LightboxState, elements: LightboxElements, index: number): void {
    if (!state.currentImages[index]) {
        return;
    }

    const image = state.currentImages[index];
    elements.img.alt = image.alt || '';
    elements.caption.textContent = image.alt || '';
    elements.current.textContent = String(index + 1);
    elements.total.textContent = String(state.currentImages.length);
    resetZoom(state, elements);
    updateNavButtons(state, elements);

    loadImageWithFallback(image.srcData).then((src) => {
        if (state.currentIndex === index) {
            elements.img.src = src;
        }
    });
}

export function goToImage(state: LightboxState, elements: LightboxElements, direction: number): void {
    state.currentIndex = (state.currentIndex + direction + state.currentImages.length) % state.currentImages.length;
    showImage(state, elements, state.currentIndex);
}

export function updateNavButtons(state: LightboxState, elements: LightboxElements): void {
    const hasMultiple = state.currentImages.length > 1;
    elements.prevBtn.classList.toggle('is-hidden', !hasMultiple);
    elements.nextBtn.classList.toggle('is-hidden', !hasMultiple);
}
